import ElementRegistry from 'diagram-js/lib/core/ElementRegistry';
import {attr as svgAttr} from 'tiny-svg';
import {AUTOMATION_ID, ELEMENT_ID} from '@ispm-shared/modules/bpmn/diagram-element-terms';
import {ModelingUtil} from "@ispm/shared/bpmn-io/modeling-util";
import {ConnectionUtils} from "@ispm-client/modules/bpmn-modeler/bpmn/utils/connection-utils";

export class PathwayElementRegistry extends ElementRegistry {
    private _elements;


    private connectionUtils: ConnectionUtils;


    constructor(eventBus, elementRegistry) {
        super(eventBus);
        this.connectionUtils = new ConnectionUtils(elementRegistry);
    }

    add(element, gfx, secondaryGfx) {
        const id = element.id;

        const automationID = this.getAutomationID(element);
        super._validateId(id);

        if (gfx) {

            // associate dom node with element
            svgAttr(gfx, ELEMENT_ID, id);
            svgAttr(gfx, AUTOMATION_ID, automationID);

            if (secondaryGfx) {
                svgAttr(secondaryGfx, ELEMENT_ID, id);
                svgAttr(secondaryGfx, AUTOMATION_ID, automationID);
            }
          if(ModelingUtil.isBpmnDefaultElement(element)){
            gfx.style.display = "none";
          }
            this._elements[id] = {element: element, gfx: gfx, secondaryGfx: secondaryGfx};
        }
        else {
          if(ModelingUtil.isBpmnDefaultElement(element)){
            element.hidden = true;
          }

            this._elements[id] = {element: element, gfx: undefined, secondaryGfx: secondaryGfx};
        }

    }

    remove(element) {
        const elements = this._elements,
            id = element.id || element,
            container = id && elements[id];

        if (container) {

            // unset element id on gfx
            if (container.gfx) {
                svgAttr(container.gfx, ELEMENT_ID, '');
                svgAttr(container.gfx, AUTOMATION_ID, '');
            }

            if (container.secondaryGfx) {
                svgAttr(container.secondaryGfx, ELEMENT_ID, '');
                svgAttr(container.secondaryGfx, AUTOMATION_ID, '');
            }

            delete elements[id];
        }
    }

    private getAutomationID(element) {
        if (ModelingUtil.isConnection(element)) {
            return this.connectionUtils.generateSequenceFlowID(element.source, element.target);
        } else {
            return element.id;
        }
    }


    public get elements() {
        return this._elements;
    }
}
